/* eslint-disable */
import React, { useEffect, useContext } from "react";
import { WebSocketContext } from "../../../App";
import wsSend_request from "../../../Api/ws/ws_request";
import { useSelector, useDispatch } from "react-redux";
import CommonDateTime from "../../Common/CommonDateTime";
import { updateOrderManagementFilter } from "../../../redux/actions/adminActions";
import MainOrderDataTableFilter from "../../Common/MainOrderDataTableFilter";
import CommonTable from "../../Common/CommonTable";

const FranchiseOrdersReport = (props) => {
  const Dispatch = useDispatch();
  const { websocket } = useContext(WebSocketContext);
  const { device_id, OrderReportList, OrderManagmentFilter, sortingfor } =
    useSelector((state) => state.adminReducers);

  // page change
  const currentFunction = (page) => {
    Dispatch(
      updateOrderManagementFilter({
        AllOrdersReport: {
          CurrentPage: page,
        },
      })
    );
  };

  // get all product list
  useEffect(() => {
    let param = {
      transmit: "broadcast",
      url: "product_list",
      request: {
        status: true,
        limit: 5000,
        page_no: 1,
        search: "",
      },
      DeviceId: device_id,
    };
    wsSend_request(websocket, param);
  }, [websocket]);

  // get all warehouse list
  useEffect(() => {
    let param = {
      transmit: "broadcast",
      url: "warehouse_list",
      request: {
        status: "",
        limit: 5000,
        page_no: 1,
        search: "",
      },
      DeviceId: device_id,
    };
    wsSend_request(websocket, param);
  }, [websocket]);

  // get all region list
  useEffect(() => {
    let param = {
      transmit: "broadcast",
      url: "region_list",
      request: {
        status: "",
        limit: 5000,
        page_no: 1,
        search: "",
      },
      DeviceId: device_id,
    };
    wsSend_request(websocket, param);
  }, [websocket]);

  // api calling
  const APICall = () => {
    const {
      SelectOrderType,
      UserLimit,
      UserSearch,
      SelectRegion,
      OrderSource,
      FromDate,
      ToDate,
      CurrentPage,
      WarehouseName,
      ProductName,
      is_bundle_orders,
    } = OrderManagmentFilter?.AllOrdersReport;

    let param = {
      transmit: "broadcast",
      url: "order_list",
      request: {
        status: SelectOrderType,
        limit: UserLimit,
        page_no: CurrentPage,
        search: UserSearch.trim(),
        from_date: null,
        to_date: null,
        from_inv: null,
        to_inv: null,
        order_type: OrderSource,
        order_data: "list",
        region_id: SelectRegion,
        order_by: sortingfor,
        fetch_location_info: true,
        is_bundle_orders: is_bundle_orders,
        include_shipments: true,
      },
      DeviceId: device_id,
    };
    if (FromDate !== "" && ToDate !== "") {
      param.request.from_date = CommonDateTime(FromDate, "YYYY-MM-DD", "hide");
      param.request.to_date = CommonDateTime(ToDate, "YYYY-MM-DD", "hide");
    }
    if (WarehouseName) {
      param.request.warehouse_id = WarehouseName?.map(
        (elm) => elm?.value
      )?.toString();
    }
    if (ProductName) {
      param.request.product_id = ProductName?.map(
        (elm) => elm?.value
      )?.toString();
    }
    wsSend_request(websocket, param);
  };

  useEffect(() => {
    APICall();
  }, [websocket, OrderManagmentFilter?.AllOrdersReport]);

  useEffect(() => {
    if (sortingfor !== "" && sortingfor !== "-") {
      APICall();
    }
  }, [sortingfor]);

  // TABLE COLUMNS ARRAY
  const TableColumns = [
    {
      key: "shipping_manifest_link",
      label: "Shipping Manifest Link",
      type: "shipping_manifest_link_download",
      sort: "",
      isCollapsable: false,
    },
    {
      key: "customer_name",
      label: "SHIP To Name",
      type: "label",
      sort: "customer_name",
      isCollapsable: false,
    },
    {
      key: "pin_code",
      label: "SHIP Pincode",
      type: "label",
      sort: "pin_code_id",
      isCollapsable: false,
    },
    {
      key: "state",
      label: "SHIP State",
      type: "label",
      sort: "state_id",
      isCollapsable: false,
    },
    {
      key: "district",
      label: "SHIP City",
      type: "label",
      sort: "district_id",
      isCollapsable: false,
    },
    {
      key: "billing_id",
      label: "BILL To Name",
      type: "label_get_from_franchise",
      sort: "billing_id",
      isCollapsable: false,
    },
    {
      key: "order_code",
      label: "Order Id.",
      type: "order_details",
      sort: "order_code",
      isCollapsable: false,
    },
    {
      key: "customer_identity",
      label: "Customer Code",
      type: "label",
      sort: "customer_identity",
      isCollapsable: false,
    },
    {
      key: "created_at",
      label: "Order Date",
      type: "date",
      sort: "created_at",
      isCollapsable: false,
    },
    {
      key: "invoice_code",
      label: "Invoice No.",
      type: "invoice_details",
      sort: "invoice_code",
      isCollapsable: false,
    },
    {
      key: "invoice_at",
      label: "Invoice Date",
      type: "date",
      sort: "invoice_at",
      isCollapsable: false,
    },
    {
      key: "dispatch_date",
      label: "Dispatch Date",
      type: "date",
      sort: "dispatch_date",
      isCollapsable: false,
    },
    {
      key: "courier_name",
      label: "Transporter",
      type: "label",
      sort: "courier_name",
      isCollapsable: false,
    },
    {
      key: "order_priority",
      label: "Order Priority",
      type: "label",
      sort: "order_priority",
      isCollapsable: false,
    },
    {
      key: "qty",
      label: "Qty",
      type: "label",
      sort: "qty",
      isCollapsable: false,
    },
    {
      key: "docket_number",
      label: "Docket Number",
      type: "label_docket_number",
      sort: "docket_number",
      isCollapsable: false,
    },
    {
      key: "total",
      label: "Amount",
      type: "label_day_ammount",
      sort: "total",
      isCollapsable: false,
    },
    {
      key: "uni_ful_fillment_tat",
      label: "Fulfillment TAT",
      type: "fulfillment_tat",
      sort: "",
      isCollapsable: false,
    },
    {
      key: "so_outstanding_breached",
      label: "SO Outstanding Breached",
      type: "status_yes_no",
      sort: "",
      isCollapsable: false,
    },
    {
      key: "order_status",
      label: "Status",
      type: "label_order_status",
      sort: "",
      isCollapsable: false,
    },
    {
      key: "shipment_logs",
      label: "Shipment Logs",
      type: "shipment_logs_type",
      sort: "shipment_logs",
      isCollapsable: true,
    },
    {
      key: "invoice_at",
      label: "Invoice Date",
      type: "date",
      sort: "",
      isCollapsable: true,
    },
    {
      key: "remark",
      label: "Remarks",
      type: "label",
      sort: "",
      isCollapsable: true,
    },
    {
      key: "",
      label: "Attachments",
      type: "label",
      sort: "",
      isCollapsable: true,
    },
    {
      key: "region_id",
      label: "Region",
      type: "label_get_from_list",
      filterFrom: { list: "regionlist", label: "region_name" },
      sort: "",
      isCollapsable: true,
    },
  ];

  return (
    <section className="Main_section">
      <MainOrderDataTableFilter
        filterType={""}
        tabName={"AllOrdersReport"}
        searchType={"Order Id, Customer Code"}
        FromDateStartDateFlag={true}
        searchdisable={true}
        buttonvisible={false}
        AllOrderStatusAllow={true}
        isAllowWarehouse={true}
        isAllowProduct={true}
        isDateType={false}
        isOdiFilterAllow={false}
        isRegionAllow={true}
        isBundleOrdersAllow={true}
        isOrderSourceAllow={true}
      />
      {/* COMMON TABLE */}
      <CommonTable
        isTableAllow={true}
        style={{
          height:
            parseInt(OrderReportList?.pagination?.total_records) ===
            OrderReportList?.list?.length
              ? "calc(100vh - 196px)"
              : parseInt(OrderReportList?.pagination?.total_records) > 10
              ? "calc(100vh - 235px)"
              : "calc(100vh - 196px)",
        }}
        srNumber={{
          clickable: true,
          events: "ORDERS_LOG",
        }}
        isCollapsable={true}
        tabName={""} // TAB URL
        PaginationCurrentPage={
          OrderManagmentFilter["AllOrdersReport"]?.CurrentPage
        } // TAB CURRENT PAGE
        PaginationFunction={currentFunction} // PAGINATION CHNAGE FUNCTION
        TableColumns={TableColumns} // TABLE COLLUMNS & ROWS
        OrderList={OrderReportList} // ORDER LIST
        Pagination={OrderReportList?.pagination} // CURRENT TAB PAGINATION
        EditAccess={false} // EDITABLE ACCESS STATE
        APIcalling={""}
        isActionColumnAvailable={{
          isShow: false,
          label: "",
          naviagte: null,
        }}
        isActionTwoColumnAvailable={{
          isShow: false,
          url: "",
        }}
        isOdiFilterRowColorsAllow={false}
      />
    </section>
  );
};

export default FranchiseOrdersReport;
